import ReactContext, { useState } from "react";
import { useEffect } from "react";
import InspectorEnCampoContext from "./InspectorEnCampoContext";

const InspectorEnCampoState = (props) => {

    //GENERALES
    const [informe, setInforme] = useState(null);
    const [informaciongeneralContext, setContextInformacionGeneral] = useState(null);
    const [responsablesContext, setContextResponsables] = useState(null);
    const [testigosContext, setContextTestigos] = useState(null);
    const [motivoContext, setContextMotivo] = useState(null);
    const [validardomicilioContext, setContextValidarDomicilio] = useState(null);
    const [fotoGaleriaContext, setContextFotoGaleria] = useState(null);
    const [buenaspracticasContext, setContextBuenasPracticas] = useState(null);

    //PRODUCCION
    const [coccionContext, setContextCoccion] = useState(null);
    const [destilacionContext, setContextDestilacion] = useState(null);
    const [fermentacionContext, setContextFermentacion] = useState(null);
    const [moliendaContext, setContextMolienda] = useState(null);
    const [pesadoContext, setContextPesado] = useState(null);

    //ENVASADO
    const [almacenGranelContext, setContextAlmacenGranel] = useState(null);
    const [areaEnvasadoContext, setContextAreaEnvasado] = useState(null);
    const [envasadoOtrosContext, setContextEnvasadoOtros] = useState(null);
    const [cuestionarioContext, setContextCuestionario] = useState(null);

    //ALMACEN
    const [productoGranelContext, setContextProductoGranel] = useState(null);
    const [productoTerminadoContext, setContextProductoTerminado] = useState(null);
    const [almacenMaduracionContext, setContextAlmacenMaduracion] = useState(null);

    useEffect(() => {
        destilacionContext
    }, [destilacionContext])

    return (
        <InspectorEnCampoContext.Provider value={
            {
                informaciongeneralContext,
                responsablesContext,
                testigosContext,
                motivoContext,
                validardomicilioContext,
                coccionContext,
                destilacionContext,
                fermentacionContext,
                moliendaContext,
                pesadoContext,
                almacenGranelContext,
                areaEnvasadoContext,
                envasadoOtrosContext,
                cuestionarioContext,
                fotoGaleriaContext,
                buenaspracticasContext,
                productoGranelContext,
                productoTerminadoContext,
                almacenMaduracionContext,
                setContextInformacionGeneral,
                setContextResponsables,
                setContextTestigos,
                setContextMotivo,
                setContextValidarDomicilio,
                setContextCoccion,
                setContextDestilacion,
                setContextFermentacion,
                setContextMolienda,
                setContextPesado,
                setContextAlmacenGranel,
                setContextAreaEnvasado,
                setContextEnvasadoOtros,
                setContextProductoGranel,
                setContextProductoTerminado,
                setContextAlmacenMaduracion,
                setContextCuestionario,
                setContextFotoGaleria,
                setContextBuenasPracticas
            }
        }>
            {props.children}
        </InspectorEnCampoContext.Provider>
    )

}

export default InspectorEnCampoState;